import { render, staticRenderFns } from "./recommendationUpdate.vue?vue&type=template&id=498f6cdf&"
import script from "./recommendationUpdate.vue?vue&type=script&lang=js&"
export * from "./recommendationUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports